const EspecialidadesStepReducer = (state, action) => {
  switch (action.type) {
    case 'SET_ESPECIALIDADES_LOADING':
      return { ...state, loadingEspecialidades: action.payload };

    case 'SET_ESPECIALIDADES':
      return { ...state, especialidades: action.payload, loadingEspecialidades: false };

    case 'SET_SUBMIT':
      return { ...state, submitting: action.payload };

    default:
      return state;
  }
};

export default EspecialidadesStepReducer;
